/*
 * PAWS & PEARLS · THE MUSE · SECRET SKY CLOUD VEIL V1.4 — PEARL MIST BEFORE SKY
 * 27 October 2026 · EXPERIMENTAL · MAGICAL MUSE WORLD duplicate ONLY
 *
 * VISUAL OVERLAY ONLY. NEVER modifies the sky geometry, scroll position,
 * existing camera/flight animation, V18 keyframes, sounds, companions or pearls.
 * Uses the EXISTING sky painting as the drifting cloud texture. NO new images.
 * V1.4 additionally brings PEARLY wisps into the ordinary Muse-page
 * ascent, before the secret sky is visible. Preserves the existing sky veil.
 * Remove only this script reference to undo everything.
 */
(function () {
  'use strict';
  var doc = document;
  var root = doc.documentElement;
  var veil, back, front, mist, sky, scene, wrapper;
  var frameId = 0, running = false, disabled = false;
  var scriptTag = doc.currentScript;
  var phase = 'cloud-veil-v1.4-early-pearl-mist';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function limit(x, lo, hi) { return Math.max(lo, Math.min(hi, x)); }
  function smooth(a, b, x) {
    var t = limit((x - a) / (b - a), 0, 1);
    return t * t * (3 - 2 * t);
  }
  function strengthAt(ms) {
    // Show during flight travel, NOT during the four companions' 4s prelude;
    // vanish over the summit hold and around the original pearl shower.
    if (ms < 16000) {
      var ascend = ms / 16000;
      return smooth(0.13, 0.39, ascend) * (1 - smooth(0.71, 0.98, ascend));
    }
    if (ms < 24000) return 0;
    var descend = (ms - 24000) / 15000;
    return smooth(0.02, 0.31, descend) * (1 - smooth(0.71, 0.96, descend));
  }
  function inactive() {
    if (veil) { veil.style.opacity = '0'; veil.style.visibility = 'hidden'; }
  }
  function stop() {
    running = false;
    if (frameId) window.cancelAnimationFrame(frameId);
    frameId = 0;
    inactive();
  }
  function texture() {
    // Match whatever image Madam has installed as the real sky.
    // Do not hardcode a filename or change the original scene style.
    var bg = window.getComputedStyle(scene).backgroundImage;
    if (bg && bg !== 'none') {
      back.style.backgroundImage = bg;
      front.style.backgroundImage = bg;
      return true;
    }
    return false;
  }
  function tick() {
    frameId = 0;
    if (!running || disabled || reduced || !veil || !veil.isConnected) { stop(); return; }
    var controller = window.ppMuseSkyJourney;
    var st = controller && typeof controller.getStatus === 'function' ? controller.getStatus() : null;
    if (!st || !st.active) { stop(); return; }

    var ms = Number(st.flightTimeMs) || 0;
    var strength = strengthAt(ms);
    if (!st.cameraFollowing) strength = 0; // Respect visitors who take over scrolling.

    // Preserve the existing sky-image veil: only draw this darker scenery
    // texture once the actual sky becomes visible.
    var s = sky.getBoundingClientRect();
    var w = wrapper.getBoundingClientRect();
    var revealed = limit((s.bottom - w.top) / Math.max(1, w.height * 0.55), 0, 1);
    strength *= revealed;

    // NEW: light pearly mist begins on the normal Muse page below the hero.
    // During the companions' four-second prelude, V18 stays paused at t=0,
    // so no premature clouds appear. Unlike the old scenery texture, the
    // early wisps are CSS gradients and never darken the lower page.
    var early = 0;
    if (ms < 16000 && st.cameraFollowing) {
      var ascend = limit(ms / 16000, 0, 1);
      early = smooth(0.035, 0.22, ascend) *
        (1 - smooth(0.50, 0.82, ascend)) *
        (1 - 0.70 * smooth(0, 1, revealed));
    }
    if (strength > 0.009 || early > 0.009) {
      var descent = ms >= 24000;
      var p = descent ? limit((ms - 24000) / 15000, 0, 1) : limit(ms / 16000, 0, 1);
      veil.style.visibility = 'visible';
      veil.style.opacity = '1';
      // Old scene texture retains the exact previous visual intensity,
      // now adjusted per layer instead of the parent overlay.
      back.style.opacity = String(0.55 * limit(strength * 0.66, 0, 0.66));
      front.style.opacity = String(0.70 * limit(strength * 0.66, 0, 0.66));
      mist.style.opacity = String(limit(early * 0.73, 0, 0.73));
      mist.style.transform = 'translate3d(' + (3 - 9 * p).toFixed(2) + '%, ' +
        (-8 - 12 * p).toFixed(2) + '%,0) scale(1.10)';
      // Opposing slow cloud parallax gives the sense of moving THROUGH
      // the clouds, without moving the sky image or the camera itself.
      back.style.transform = 'translate3d(' + (-2 + 5 * p).toFixed(2) + '%, ' + (descent ? -16 + 26 * p : 16 - 26 * p).toFixed(2) + '%, 0) scale(1.08)';
      front.style.transform = 'translate3d(' + (3 - 7 * p).toFixed(2) + '%, ' + (descent ? -26 + 42 * p : 26 - 42 * p).toFixed(2) + '%, 0) scale(1.18)';
    } else {
      inactive();
    }
    frameId = window.requestAnimationFrame(tick);
  }
  function start() {
    if (running || disabled || reduced || !veil) return;
    if (!texture()) return;
    running = true;
    frameId = window.requestAnimationFrame(tick);
  }
  function init() {
    if (reduced || !root.classList.contains('pp-muse-secret-sky-page')) return;
    if (doc.getElementById('pp-muse-cloud-veil-early-v1')) return;
    sky = doc.getElementById('pp-muse-secret-sky');
    scene = sky && sky.querySelector('.pp-muse-sky-scene');
    wrapper = doc.querySelector('.page-wrapper');
    if (!sky || !scene || !wrapper || !wrapper.contains(sky)) return;

    var css = doc.createElement('style');
    css.id = 'pp-muse-cloud-veil-early-v1-css';
    css.textContent = [
      '#pp-muse-cloud-veil-early-v1{position:fixed!important;inset:0!important;',
      'pointer-events:none!important;user-select:none!important;overflow:hidden!important;',
      'z-index:2147483001!important;opacity:0;visibility:hidden;isolation:isolate;',
      'contain:layout paint style;}',
      '#pp-muse-cloud-veil-early-v1 .pp-muse-cloud-sheet{position:absolute;inset:-12% -14%;',
      'pointer-events:none!important;background-repeat:no-repeat;background-position:center bottom;',
      'background-size:auto 210%;will-change:transform;}',
      '#pp-muse-cloud-veil-early-v1 .pp-muse-cloud-back{opacity:.55;filter:blur(5px);',
      '-webkit-mask-image:linear-gradient(to bottom,transparent 4%,#000 29%,#000 69%,transparent 96%);',
      'mask-image:linear-gradient(to bottom,transparent 4%,#000 29%,#000 69%,transparent 96%);}',
      '#pp-muse-cloud-veil-early-v1 .pp-muse-cloud-front{opacity:.7;filter:blur(10px);',
      '-webkit-mask-image:radial-gradient(ellipse 78% 62% at 48% 55%,#000 2%,transparent 90%);',
      'mask-image:radial-gradient(ellipse 78% 62% at 48% 55%,#000 2%,transparent 90%);}',
      // Diffuse pearls and peach-tinted cloudlets in the LOWER viewport only.
      // Header/upper hero remain unobstructed. No extra image asset.
      '#pp-muse-cloud-veil-early-v1 .pp-muse-cloud-early{position:absolute;left:-15%;right:-15%;',
      'top:26%;height:84%;pointer-events:none;opacity:0;will-change:transform,opacity;',
      'filter:blur(23px);background:',
      'radial-gradient(ellipse 36% 31% at 10% 73%,rgba(255,246,235,.85) 0%,rgba(255,228,229,.38) 53%,transparent 99%),',
      'radial-gradient(ellipse 37% 32% at 83% 71%,rgba(255,249,242,.9) 0%,rgba(252,222,228,.36) 57%,transparent 100%),',
      'radial-gradient(ellipse 42% 32% at 52% 94%,rgba(255,249,239,.88) 0%,rgba(255,224,216,.35) 54%,transparent 100%),',
      'radial-gradient(ellipse 38% 28% at 40% 60%,rgba(255,251,244,.5) 0%,transparent 92%);',
      '-webkit-mask-image:linear-gradient(to bottom,transparent,rgba(0,0,0,.05) 18%,#000 65%);',
      'mask-image:linear-gradient(to bottom,transparent,rgba(0,0,0,.05) 18%,#000 65%);}',
      '@media(prefers-reduced-motion:reduce){#pp-muse-cloud-veil-early-v1{display:none!important;}}'
    ].join('');
    doc.head.appendChild(css);
    veil = doc.createElement('div');
    veil.id = 'pp-muse-cloud-veil-early-v1';
    veil.setAttribute('aria-hidden', 'true');
    back = doc.createElement('div');
    back.className = 'pp-muse-cloud-sheet pp-muse-cloud-back';
    front = doc.createElement('div');
    front.className = 'pp-muse-cloud-sheet pp-muse-cloud-front';
    mist = doc.createElement('div');
    mist.className = 'pp-muse-cloud-early';
    veil.appendChild(back);
    veil.appendChild(front);
    veil.appendChild(mist);
    doc.body.appendChild(veil);

    // This listener runs AFTER the established V18 and V1.1 journey listeners.
    // It observes their timing, but never modifies their operation.
    doc.addEventListener('click', function (event) {
      var hit = event.target && event.target.closest &&
        event.target.closest('#pp-muse-balloon-stage .pp-balloon, .pp-muse-flight-overlay.pp-balloon');
      if (!hit) return;
      window.setTimeout(start, 30);
    });
    doc.addEventListener('shopify:section:unload', function (event) {
      if (event.target && event.target.contains(sky)) stop();
    });
  }
  window.ppMuseCloudVeil = {
    version: phase,
    disable: function () { disabled = true; stop(); },
    enable: function () { disabled = false; },
    getStatus: function () { return { version:phase, active:running, disabled:disabled, visible:!!(veil && veil.style.visibility==='visible'), opacity:veil?Number(veil.style.opacity)||0:0 }; }
  };
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init, { once:true });
  else init();
})();
